import { SITE_URL } from "@shared/lib/hosts";

/**
 * Signature des e-mails du SDR « comme dans Gmail » (réglage `signatureRich`) :
 * le logo Hune, le nom de la boîte, la ligne de signature des réglages, le
 * lien vers le site et la promesse. Même gabarit que les signatures du studio
 * marketing (marketing/studio/templates/banners.mjs). Seule exception à la
 * règle « aucun lien dans la séquence » (docs/PROSPECTION_SDR.md) : le corps,
 * lui, n'en contient jamais. Sans dépendance serveur : l'écran des réglages en
 * montre l'aperçu.
 */

export const SIGNATURE_TAGLINE = "Trouvez vos futurs clients au bon moment.";

const INK = "#111114";
const MUTED = "#62626b";
const SLATE = "#2a496f";
const RULE = "#ececef";
const FONT = "Arial, Helvetica, sans-serif";

export function escapeHtml(value: string) {
  return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}

/** « hune-app.com » : le site tel qu'on le lit dans la signature. */
export function siteLabel(siteUrl = SITE_URL) {
  return siteUrl.replace(/^https?:\/\//i, "").replace(/^www\./i, "").replace(/\/$/, "");
}

/** Signature HTML : un tableau, des polices système, le logo servi par le site. */
export function richSignatureHtml(name: string, role: string, siteUrl = SITE_URL) {
  return `<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse:collapse;font-family:${FONT}">
  <tr>
    <td style="padding:0 14px 0 0;vertical-align:middle"><img src="${siteUrl}/brand/hune-logo-email@2x.png" width="92" height="32" alt="Hune" style="display:block;width:92px;height:32px;border:0"></td>
    <td style="padding:0 0 0 14px;border-left:1px solid ${RULE};vertical-align:middle;font-family:${FONT};font-size:13px;line-height:18px;color:${MUTED}">
      <span style="font-size:14px;font-weight:600;color:${INK}">${escapeHtml(name)}</span><br>
      ${escapeHtml(role)}<br>
      <a href="${siteUrl}" style="color:${SLATE};text-decoration:none">${escapeHtml(siteLabel(siteUrl))}</a>
    </td>
  </tr>
  <tr><td colspan="2" style="padding-top:10px;font-family:${FONT};font-size:13px;line-height:18px;color:${MUTED}">${SIGNATURE_TAGLINE}</td></tr>
</table>`;
}

/** La même signature dans la partie texte du message. */
export function richSignatureText(name: string, role: string, siteUrl = SITE_URL) {
  return `${name}\n${role}\n${siteLabel(siteUrl)}\n\n${SIGNATURE_TAGLINE}`;
}

/** Un texte brut en HTML de messagerie : paragraphes et retours à la ligne, rien d'autre. */
export function plainTextToHtml(text: string) {
  return text
    .trim()
    .split(/\n{2,}/)
    .map((paragraph) => `<p style="margin:0 0 14px">${escapeHtml(paragraph).replace(/\n/g, "<br>")}</p>`)
    .join("\n");
}
